import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import FundingSummary from './section-components/funding-summary';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Invested Project"  />
        <FundingSummary />
        <Footer />
    </div>
}

export default SignInPage

